import React, { ReactElement, ReactNode } from 'react';

import { Tooltip, TooltipProps } from '@mui/material';

const COLOR = '#4D4D4D';
const TXT_COLOR = 'var(--secondary-light-text)';

const tooltipSx = {
  background: COLOR,
  color: TXT_COLOR,
  padding: '0.5rem',
  borderRadius: '4px',
  border: '1px solid #707070',
  alignItems: 'flex-start',
  fontSize: '0.875rem',
  filter: 'none',
  WebkitFilter: 'none',
  fontWeight: 400,
  whiteSpace: 'pre-line',
  marginBottom: '7px !important', // default is 14
};

const tooltipArrowSx = {
  color: COLOR,
};

interface IStlTooltip {
  title: ReactNode;
  children: ReactElement;
  placement?: TooltipProps['placement'];
  enterDelay?: TooltipProps['enterDelay'];
  width?: number;
  arrow?: boolean;
}

export default function StlTooltip({
  title,
  children,
  placement = 'top-start',
  enterDelay,
  width,
  arrow = true,
}: IStlTooltip) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={enterDelay}
      enterNextDelay={enterDelay}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            ...tooltipSx,
            width,
          },
        },
        arrow: {
          sx: arrow ? tooltipArrowSx : { display: 'none' },
        },
      }}
    >
      {children}
    </Tooltip>
  );
}
